import { render } from "./AccordionContent.vue?vue&type=template&id=5144b018"
import script from "./AccordionContent.vue?vue&type=script&lang=js"
export * from "./AccordionContent.vue?vue&type=script&lang=js"

import "./AccordionContent.vue?vue&type=style&index=0&id=5144b018&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__